import { getTodayForUser } from '~/modules/common/dates/today';
import { useMeContext } from '~/modules/me';
import {
  useResourceRequestMatches,
  useGetResourceUser
} from '~/modules/resourcing/common/hooks';

export const useGetResourceMatchRowData = ({ resourceRequestUri }) => {
  const me = useMeContext();
  const { loading, resourceMatches } = useResourceRequestMatches({
    page: 1,
    pageSize: 4,
    resourceRequestUri
  });
  const resourceRequestResourceMatch = resourceMatches || [];

  const { loading: loading2, resourceUsers } = useGetResourceUser({
    page: 1,
    pageSize: 4,
    userUris: resourceRequestResourceMatch.map(
      resourceMatch => resourceMatch.userUri
    ),
    date: getTodayForUser(me),
    skip: loading
  });

  return {
    loading: loading || loading2,
    userResourceMatchesMap: resourceRequestResourceMatch.map(resourceMatch => ({
      user: resourceUsers.find(
        resourceUser => resourceUser.id === resourceMatch.userUri
      ),
      resourceMatch
    }))
  };
};

export default useGetResourceMatchRowData;
